import React, { useState } from 'react'
import ModalSponsorRegister from './ModalSponsorRegister'
import { useTranslation } from 'react-i18next'

export default function ButtonSponsorRegister({ sponsor_package_id, duration }) {
  const [isOpen, setisOpen] = useState(false)
  const { t } = useTranslation()
  function handleOnClickOpenModal() {
    setisOpen(true)
  }
  function handleOnClickCloseModal() {
    setisOpen(false)
  }

  return (
    <>
      <button
        onClick={handleOnClickOpenModal}
        className="flex items-center justify-center w-full p-3 text-white bg-primary-600 hover:bg-secondary-600"
      >
        {t('subscribe_with_us')}
      </button>
      <ModalSponsorRegister
        isOpen={isOpen}
        onClose={handleOnClickCloseModal}
        sponsor_package_id={sponsor_package_id}
        duration={duration}
      />
    </>
  )
}
